import { Component, Input } from '@angular/core';
import { RouteConfig } from '../header.component';

@Component({
  selector: 'markant-platform-header-navigation',
  templateUrl: './header-navigation.component.html',
  styleUrls: ['./header-navigation.component.scss'],
})
export class HeaderNavigationComponent {
  @Input({ required: true }) activeIndex!: number;
  @Input() routes: RouteConfig[] = [];
}
